import { render, staticRenderFns } from "./CategoryMedia.vue?vue&type=template&id=62b6bac0&scoped=true&"
import script from "./CategoryMedia.vue?vue&type=script&lang=js&"
export * from "./CategoryMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6bac0",
  null
  
)

export default component.exports